import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Pricing = () => {
  const freeFeatures = [
    '10 free units every month',
    'Use across Call, SMS, Email, and AI Agent usage',
    'No credit card required to start',
    'Charges billed monthly - auto-deducted'
  ];

  return (
    <section id="pricing" className="pricing-section">
      <div className="section-container">
        <div className="section-header reveal centered">
          <div className="section-label">Pricing</div>
          <h2 className="section-title">Simple, Scalable Pricing</h2>
          <p className="section-description">
            Start free. Scale as you grow. No surprise bills.
          </p>
        </div>
        
        <div className="pricing-card reveal">
          <Badge className="pricing-badge">Pay As You Go</Badge>
          <h3 className="pricing-title">Start Free. Scale Infinitely.</h3>
          <p className="pricing-description">
            Begin every month with 10 free units across communication and AI usage.
          </p>
          
          <ul className="pricing-features">
            {freeFeatures.map((feature, index) => (
              <li key={index}>
                <FontAwesomeIcon icon={faCheck} />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          
          <div className="pricing-actions">
            <Button size="lg" asChild>
              <a href="https://sso.contexttocall.com/realms/c2cp1/protocol/openid-connect/registrations?client_id=c2c-biz-app&redirect_uri=https%3A%2F%2Fapp.contexttocall.com&response_type=code" target="_blank" rel="noopener noreferrer">
                Get Started Free <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </Button>
            
          </div>
        </div>
        
        <div className="cta-banner reveal">
          <h2>Ready to Transform Your Customer Communication?</h2>
          <p>
            Join businesses in 112+ countries using Context to Call to connect smarter, convert faster, and grow bigger.
          </p>
          <div className="cta-actions">
            <Button size="lg" asChild>
              <a href="https://sso.contexttocall.com/realms/c2cp1/protocol/openid-connect/registrations?client_id=c2c-biz-app&redirect_uri=https%3A%2F%2Fapp.contexttocall.com&response_type=code" target="_blank" rel="noopener noreferrer">
                Get Started Free <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <a href="https://outlook.office365.com/book/RequestDemo@vgroupinc.com/" target="_blank" rel="noopener noreferrer">
                Book a Demo
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
